import { render } from "./FadedBackground.vue?vue&type=template&id=2a5f26ff"
import script from "./FadedBackground.vue?vue&type=script&lang=js"
export * from "./FadedBackground.vue?vue&type=script&lang=js"

import "./FadedBackground.vue?vue&type=style&index=0&id=2a5f26ff&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__